import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios';
import cookie from 'js-cookie';

const API_URL = import.meta.env.VITE_API_URL;
const API_KEY = import.meta.env.VITE_API_KEY;
const MODE = import.meta.env.MODE;

const axiosConfig: AxiosRequestConfig = {
  baseURL: `${API_URL}`,
  headers: {
    'Content-Type': 'application/json'
  }
};

const VDLInstance: AxiosInstance = axios.create(axiosConfig);

let token;

if (import.meta.env.DEV) {
  token = API_KEY;
} else {
  token = cookie.get(import.meta.env.VITE_TOKEN_KEY);
}

VDLInstance.interceptors.request.use(
  async (config) => {
    config.headers.Authorization = 'Bearer ' + token;

    return config;
  },
  (error) => {
    return Promise.reject(new Error(`Request error: ${error.message}`));
  }
);

VDLInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 401 && MODE !== 'development') {
        const authPath = import.meta.env.VITE_AUTH_PATH;

        if (!authPath) throw Error('auth path is not defined');
        window.location.href = authPath;
      } else {
        return Promise.reject(error);
      }

      throw new Error('Unexpected resonse error', error);
    }
  }
);

export default VDLInstance;
